import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router";

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import './index.css';
import App from './App';

import { Provider } from 'react-redux'
import store from './redux/store'
import Swal from 'sweetalert2';
import packageJson from '../package.json';

const currentVersion = packageJson.version;
const storedVersion = localStorage.getItem('appVersion');

if (storedVersion && storedVersion !== currentVersion) {
	Swal.fire({
		title: '¡App Actualizada!',
		text: `La aplicación se ha actualizado con éxito a la versión ${currentVersion}.`,
		icon: 'success',
		confirmButtonText: 'Genial'
	});
}

localStorage.setItem('appVersion', currentVersion);

const root = document.getElementById("root");

ReactDOM.createRoot(root).render(
	<React.StrictMode>
		<BrowserRouter basename={process.env.PUBLIC_URL}>
			<Provider store={store}>
				<App />
			</Provider>
		</BrowserRouter>
	</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
	onUpdate: (registration) => {
		const waitingServiceWorker = registration.waiting;

		if (waitingServiceWorker) {
			// 1. Avisar al service worker que se active (skipWaiting)
			waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });

			// 2. Mostrar un mensaje al usuario para recargar
			Swal.fire({
				title: '¡Nueva actualización!',
				text: 'Hay una nueva versión disponible',
				icon: 'info',
				confirmButtonText: 'Actualizar',
				allowOutsideClick: false
			}).then((result) => {
				if (result.isConfirmed) {
					window.location.reload();
				}
			});
		}
	}
});

